import React, { useState } from 'react';
import { skills, Skill } from '../data/portfolioData';
import Icon from './Icon';
import useScrollReveal from '../hooks/useScrollReveal';
import './Skills.css';

type FilterCategory = 'all' | Skill['category'];

const categoryLabels: Record<FilterCategory, string> = {
  all: 'Tutti',
  frontend: 'Frontend',
  backend: 'Backend',
  devops: 'DevOps & CI/CD',
  data: 'Database & Big Data',
  agile: 'Agile & Tools',
};

const Skills: React.FC = () => {
  const [filter, setFilter] = useState<FilterCategory>('all');
  const { ref, isVisible } = useScrollReveal();

  const filteredSkills = filter === 'all'
    ? skills
    : skills.filter(s => s.category === filter);

  const categories: FilterCategory[] = ['all', 'backend', 'frontend', 'data', 'devops', 'agile'];

  return (
    <section id="skills" className="section skills" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title">Skills & Tecnologie</h2>
        <p className="section-subtitle">
          Le tecnologie con cui lavoro ogni giorno.
        </p>

        <div className="skills-filter">
          {categories.map(cat => (
            <button
              key={cat}
              className={`filter-btn ${filter === cat ? 'active' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {categoryLabels[cat]}
            </button>
          ))}
        </div>

        <div className="skills-grid">
          {filteredSkills.map((skill, index) => (
            <div
              key={skill.name}
              className="skill-card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="skill-icon" style={{ color: skill.color }}>
                <Icon icon={skill.icon} />
              </div>
              <div className="skill-name">{skill.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;

